// // // import React from 'react';
// // // import './DetailsCard2.css';
// // // import { User, Calendar, Tag, Layers, FileText, Users, IdCard, Download } from 'lucide-react';

// // // function DetailsCard1({ data, onDownload }) {
// // //     const {
// // //         ProjectId,
// // //         ProjectTitle = "Untitled Project",
// // //         ProjectSupervisor = "N/A",
// // //         Project_Type = "N/A",
// // //         Department = "N/A",
// // //         AdditionalInfo = {},
// // //         Year = ProjectId ? ProjectId.substring(0, 4) : "N/A"
// // //     } = data || {};

// // //     const studentNames = AdditionalInfo?.StudentNames?.split(', ') || [];
// // //     const htNos = AdditionalInfo?.HTNos?.split(', ') || [];
// // //     const Domain = AdditionalInfo?.Domain || null;

// // //     const studentsList = studentNames.map((name, index) => ({
// // //         name: name.trim(),
// // //         htNo: htNos[index] ? htNos[index].trim() : 'N/A'
// // //     }));

// // //     const getGradientColor = () => {
// // //         const deptColors = {
// // //             'CSE': 'from-blue-600 to-indigo-700',
// // //             'IT': 'from-purple-600 to-pink-700',
// // //             'ECE': 'from-green-600 to-teal-700',
// // //             'EIE': 'from-yellow-600 to-amber-700',
// // //             'ME': 'from-orange-600 to-red-700',
// // //             'CE': 'from-cyan-600 to-blue-700',
// // //             'EEE': 'from-indigo-600 to-violet-700',
// // //             'AIML': 'from-pink-600 to-rose-700'
// // //         };

// // //         if (Department.includes('-')) {
// // //             for (const key in deptColors) {
// // //                 if (Department.includes(key)) return deptColors[key];
// // //             }
// // //         }

// // //         return deptColors[Department] || 'from-slate-600 to-gray-700';
// // //     };

// // //     return (
// // //         <div className="project-card">
// // //             <div className={`card-header bg-gradient-to-r ${getGradientColor()}`}>
// // //                 <div className="card-badge">{Project_Type}</div>
// // //             </div>

// // //             <div className="card-body">
// // //                 <h3 className="card-title" title={ProjectTitle}>{ProjectTitle}</h3>

// // //                 <div className="card-details">
// // //                     <div className="detail-item">
// // //                         <User className="detail-icon" size={16} />
// // //                         <span title={ProjectSupervisor}>{ProjectSupervisor}</span>
// // //                     </div>

// // //                     <div className="detail-item">
// // //                         <Layers className="detail-icon" size={16} />
// // //                         <span>{Department}</span>
// // //                     </div>

// // //                     {Domain && (
// // //                         <div className="detail-item">
// // //                             <Tag className="detail-icon" size={16} />
// // //                             <span>{Domain}</span>
// // //                         </div>
// // //                     )}

// // //                     <div className="detail-item">
// // //                         <Calendar className="detail-icon" size={16} />
// // //                         <span>{Year}</span>
// // //                     </div>

// // //                     {studentsList.length > 0 && (
// // //                         <div className="detail-item">
// // //                             <Users className="detail-icon" size={16} />
// // //                             <span title={studentNames.join(', ')}>
// // //                                 {studentsList.slice(0, 2).map(s => s.name).join(', ')}
// // //                                 {studentsList.length > 2 ? '...' : ''}
// // //                             </span>
// // //                         </div>
// // //                     )}

// // //                     {htNos.length > 0 && (
// // //                         <div className="detail-item">
// // //                             <IdCard className="detail-icon" size={16} />
// // //                             <span title={htNos.join(', ')}>
// // //                                 {htNos.slice(0, 2).join(', ')}
// // //                                 {htNos.length > 2 ? '...' : ''}
// // //                             </span>
// // //                         </div>
// // //                     )}

// // //                     <div className="detail-item">
// // //                         <FileText className="detail-icon" size={16} />
// // //                         <span className="project-id" title={ProjectId}>{ProjectId}</span>
// // //                     </div>
// // //                 </div>
// // //             </div>
// // //         </div>
// // //     );
// // // }

// // // export default DetailsCard1;


// // import React from 'react';
// // import './DetailsCard2.css';
// // import { User, Calendar, Tag, Layers, FileText, Users, IdCard, Download } from 'lucide-react';

// // function DetailsCard1({ data, onDownload }) {
// //     const {
// //         ProjectId,
// //         ProjectTitle = "Untitled Project",
// //         ProjectSupervisor = "N/A",
// //         Project_Type = "N/A",
// //         Department = "N/A",
// //         AdditionalInfo = {},
// //         Year = ProjectId ? ProjectId.substring(0, 4) : "N/A"
// //     } = data || {};

// //     const studentNames = AdditionalInfo?.StudentNames?.split(', ') || [];
// //     const htNos = AdditionalInfo?.HTNos?.split(', ') || [];
// //     const Domain = AdditionalInfo?.Domain || null;

// //     const studentsList = studentNames.map((name, index) => ({
// //         name: name.trim(),
// //         htNo: htNos[index] ? htNos[index].trim() : 'N/A'
// //     }));

// //     const getGradientColor = () => {
// //         const deptColors = {
// //             'CSE': 'from-blue-600 to-indigo-700',
// //             'IT': 'from-purple-600 to-pink-700',
// //             'ECE': 'from-green-600 to-teal-700',
// //             'EIE': 'from-yellow-600 to-amber-700',
// //             'ME': 'from-orange-600 to-red-700',
// //             'CE': 'from-cyan-600 to-blue-700',
// //             'EEE': 'from-indigo-600 to-violet-700',
// //             'AIML': 'from-pink-600 to-rose-700'
// //         };

// //         if (Department.includes('-')) {
// //             for (const key in deptColors) {
// //                 if (Department.includes(key)) return deptColors[key];
// //             }
// //         }

// //         return deptColors[Department] || 'from-slate-600 to-gray-700';
// //     };

// //     return (
// //         <div className="project-card">
// //             <div className={`card-header bg-gradient-to-r ${getGradientColor()}`}>
// //                 <div className="card-badge">{Project_Type}</div>
// //             </div>

// //             <div className="card-body">
// //                 <h3 className="card-title" title={ProjectTitle}>{ProjectTitle}</h3>

// //                 <div className="card-details">
// //                     <div className="detail-item">
// //                         <User className="detail-icon" size={16} />
// //                         <span title={ProjectSupervisor}>{ProjectSupervisor}</span>
// //                     </div>

// //                     <div className="detail-item">
// //                         <Layers className="detail-icon" size={16} />
// //                         <span>{Department}</span>
// //                     </div>

// //                     {Domain && (
// //                         <div className="detail-item">
// //                             <Tag className="detail-icon" size={16} />
// //                             <span>{Domain}</span>
// //                         </div>
// //                     )}

// //                     <div className="detail-item">
// //                         <Calendar className="detail-icon" size={16} />
// //                         <span>{Year}</span>
// //                     </div>

// //                     {studentsList.length > 0 && (
// //                         <div className="detail-item">
// //                             <Users className="detail-icon" size={16} />
// //                             <div title={studentsList.map(s => `${s.name} (${s.htNo})`).join(', ')}>
// //                                 {studentsList.slice(0, 2).map((s, idx) => (
// //                                     <div key={idx} className="student-entry">
// //                                         {s.name} ({s.htNo})
// //                                     </div>
// //                                 ))}
// //                                 {studentsList.length > 2 && <div>...</div>}
// //                             </div>
// //                         </div>
// //                     )}

// //                     <div className="detail-item">
// //                         <FileText className="detail-icon" size={16} />
// //                         <span className="project-id" title={ProjectId}>{ProjectId}</span>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // }

// // export default DetailsCard1;
// import React from 'react';
// import './DetailsCard2.css';
// import { User, Calendar, Tag, Layers, FileText, Users, IdCard, Download } from 'lucide-react';

// function DetailsCard1({ data, onDownload }) {
//     const {
//         ProjectId,
//         ProjectTitle = "Untitled Project",
//         ProjectSupervisor = "N/A",
//         Project_Type = "N/A",
//         Department = "N/A",
//         AdditionalInfo = {},
//         Year = ProjectId ? ProjectId.substring(0, 4) : "N/A"
//     } = data || {};

//     const studentNames = AdditionalInfo?.StudentNames?.split(', ') || [];
//     const htNos = AdditionalInfo?.HTNos?.split(', ') || [];
//     const Domain = AdditionalInfo?.Domain || null;

//     const studentsList = studentNames.map((name, index) => ({
//         name: name.trim(),
//         htNo: htNos[index] ? htNos[index].trim() : 'N/A'
//     }));

//     const getGradientColor = () => {
//         const deptColors = {
//             'CSE': 'from-blue-600 to-indigo-700',
//             'IT': 'from-purple-600 to-pink-700',
//             'ECE': 'from-green-600 to-teal-700',
//             'EIE': 'from-yellow-600 to-amber-700',
//             'ME': 'from-orange-600 to-red-700',
//             'CE': 'from-cyan-600 to-blue-700',
//             'EEE': 'from-indigo-600 to-violet-700',
//             'AIML': 'from-pink-600 to-rose-700'
//         };

//         if (Department.includes('-')) {
//             for (const key in deptColors) {
//                 if (Department.includes(key)) return deptColors[key];
//             }
//         }

//         return deptColors[Department] || 'from-slate-600 to-gray-700';
//     };

//     return (
//         <div className="project-card" style={{ backgroundColor: '#f3f4f6' }}>
//             <div className={`card-header bg-gradient-to-r ${getGradientColor()}`}>
//                 <div className="card-badge">{Project_Type}</div>
//             </div>

//             <div className="card-body">
//                 <h3 className="card-title" title={ProjectTitle}>{ProjectTitle}</h3>

//                 <div className="card-details">
//                     <div className="detail-item">
//                         <User className="detail-icon" size={16} />
//                         <span title={ProjectSupervisor}>{ProjectSupervisor}</span>
//                     </div>

//                     <div className="detail-item">
//                         <Layers className="detail-icon" size={16} />
//                         <span>{Department}</span>
//                     </div>

//                     {Domain && (
//                         <div className="detail-item">
//                             <Tag className="detail-icon" size={16} />
//                             <span>{Domain}</span>
//                         </div>
//                     )}

//                     <div className="detail-item">
//                         <Calendar className="detail-icon" size={16} />
//                         <span>{Year}</span>
//                     </div>

//                     {studentsList.length > 0 && (
//                         <div className="detail-item">
//                             <Users className="detail-icon" size={16} />
//                             <div title={studentsList.map(s => `${s.name} (${s.htNo})`).join(', ')}>
//                                 {studentsList.map((s, idx) => (
//                                     <div key={idx} className="student-entry">
//                                         {s.name} ({s.htNo})
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     )}

//                     <div className="detail-item">
//                         <FileText className="detail-icon" size={16} />
//                         <span className="project-id" title={ProjectId}>{ProjectId}</span>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default DetailsCard1;
import React from 'react';
import './DetailsCard1.css';
import { User, Calendar, Tag, Layers, FileText, Users } from 'lucide-react';

function DetailsCard1({ data, onDownload }) {
    const {
        ProjectId,
        ProjectTitle = "Untitled Project",
        ProjectSupervisor = "N/A",
        Project_Type = "N/A",
        Department = "N/A",
        AdditionalInfo = {},
        Year = ProjectId ? ProjectId.substring(0, 4) : "N/A"
    } = data || {};

    const studentNames = AdditionalInfo?.StudentNames?.split(', ') || [];
    const htNos = AdditionalInfo?.HTNos?.split(', ') || [];
    const Domain = AdditionalInfo?.Domain || null;

    const studentsList = studentNames.map((name, index) => ({
        name: name.trim(),
        htNo: htNos[index] ? htNos[index].trim() : 'N/A'
    }));

    const getGradientColor = () => {
        const deptColors = {
            'CSE': 'from-blue-600 to-indigo-700',
            'IT': 'from-purple-600 to-pink-700',
            'ECE': 'from-green-600 to-teal-700',
            'EIE': 'from-yellow-600 to-amber-700',
            'ME': 'from-orange-600 to-red-700',
            'CE': 'from-cyan-600 to-blue-700',
            'EEE': 'from-indigo-600 to-violet-700',
            'AIML': 'from-pink-600 to-rose-700'
        };

        // Extract main department before hyphen if any (e.g. "B.Tech-Major" -> "B.Tech")
        const mainDept = Department.includes('-') ? Department.split('-')[0].trim() : Department;

        return deptColors[mainDept] || 'from-slate-600 to-gray-700';
    };

    return (
        <div className="project-card" style={{ backgroundColor: '#f3f4f6' }}>
            <div className={`card-header bg-gradient-to-r ${getGradientColor()}`}>
                <div className="card-badge">{Project_Type}</div>
            </div>

            <div className="card-body">
                <h3 className="card-title" title={ProjectTitle}>{ProjectTitle}</h3>

                <div className="card-details">
                    <div className="detail-item">
                        <User className="detail-icon" size={16} />
                        <span title={ProjectSupervisor}>{ProjectSupervisor}</span>
                    </div>

                    <div className="detail-item">
                        <Layers className="detail-icon" size={16} />
                        <span>{Department}</span>
                    </div>

                    {Domain && (
                        <div className="detail-item">
                            <Tag className="detail-icon" size={16} />
                            <span>{Domain}</span>
                        </div>
                    )}

                    <div className="detail-item">
                        <Calendar className="detail-icon" size={16} />
                        <span>{Year}</span>
                    </div>

                    {studentsList.length > 0 && (
                        <div className="detail-item">
                            <Users className="detail-icon" size={16} />
                            <div title={studentsList.map(s => `${s.name} (${s.htNo})`).join(', ')}>
                                {studentsList.map((s, idx) => (
                                    <div key={idx} className="student-entry">
                                        {s.name} ({s.htNo})
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="detail-item">
                        <FileText className="detail-icon" size={16} />
                        <span className="project-id" title={ProjectId}>{ProjectId}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DetailsCard1;
